import { Routes, Route } from "react-router-dom";
import { NewsSinglePost, Header, Footer } from "../components";
import { React, useEffect, useState } from "react";
import createClient from '../Client';
import { Home, StaticPages } from "../pages";


const Router = ({ setLoading }) => {
    const [MenuData, setMenuData] = useState([]);
    const [headerLogo, setHeaderLogo] = useState([]);
    const [footerData, setFooterData] = useState([]);

    useEffect(() => {
        createClient.fetch(`*[_type=="settings"][0] {
        "headerMenu":settings_header_menu.links[]{
          ...,
         
          (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
        },
        "headerLogo":settings_header_logo.asset->url,

          "footer1":settings_footer_menu_1.links[]{
          ...,
          (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
        },
        "footer2":settings_footer_menu_2{
          ...,
          "footerMenu2":settings_footer_menu_2_items.links[] {
            ...,
            (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
          },
          "footerTitle":settings_footer_menu_2_title_text
        },
        "footer3":settings_footer_menu_3{
          ...,
          "footerMenu3":settings_footer_menu_3_items.links[] {
            ...,
            (_type == "linkInternal") => {
              (display == "link_href") => {
                "slug" : ref_link_href
              },
              (display == "link_url") => {
                "slug" : reference->page_slug.current
              }
            },
            (_type == "linkExternal") => {
              "slug" : url
            }
          },
          "footerTitle":settings_footer_menu_3_title_text
        },
        "footerLogo":settings_footer_logo.asset->url,
        "footerContent": settings_footer_content,
        "copywright": settings_footer_copyright_text,
        "twiter": settings_footer_social_icons.settings_footer_social_icons_x,
        "fb":settings_footer_social_icons.settings_footer_social_icons_fb,
        "insta":settings_footer_social_icons.settings_footer_social_icons_insta,
        ...,
      }`).then((data) => {
            setMenuData(data.headerMenu);
            setHeaderLogo(data.headerLogo);
            setFooterData(data);
        })
            .catch(console.error);
    }, [])


    return (
        <>
            <Header items={MenuData} headerlogo={headerLogo}></Header>
            <Routes>
            {/* this is static, static page about-us is changed to home */}
                <Route path='/' element={<Home setLoading={setLoading} footerData={footerData} items={MenuData}></Home>}></Route>
                <Route path='/:slugId' element={<StaticPages setLoading={setLoading} footerData={footerData} items={MenuData} ></StaticPages>}></Route>
                {/* <Route path='/' element={<StaticPages></StaticPages>}></Route> */}
                <Route path='/news/:postId' element={<NewsSinglePost setLoading={setLoading} footerData={footerData} items={MenuData}></NewsSinglePost>}></Route>
            </Routes>
            {/* <Footer footerData={footerData} items={MenuData}></Footer> */}
        </>
    );
}

export default Router;